export default __webpack_public_path__ + "static/media/IHRA_Logo.c99f0074.png";